<template>
    <div class="table-footer">
        <span class="range">{{ rangeLabel }}</span>
        <v-spacer />
        <v-pagination
            v-if="pageCount > 1"
            :value="value"
            :length="pageCount"
            :total-visible="7"
            @input="$emit('input', $event)"
        />
    </div>
</template>

<script>
    export default {
        name: 'TableFooter',
        props: {
            value: {
                type: Number,
                default: 1
            },
            pageCount: {
                type: Number,
                default: 0
            },
            total: {
                type: Number,
                default: 0
            },
            itemsPerPage: {
                type: Number,
                default: 10
            }
        },
        computed: {
            rangeLabel() {
                if (!this.total) {
                    return 'No results'
                }
                const from = (this.value - 1) * this.itemsPerPage + 1
                const to = Math.min(this.value * this.itemsPerPage, this.total)
                return `${from}–${to} of ${this.total}`
            }
        }
    }
</script>

<style scoped>
.table-footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    min-height: 56px;
    padding: 4px 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.range {
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.6);
}
</style>
